import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export const StickyCTA = ({ onBook }) => {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const scrolled = window.scrollY;
      const total = document.documentElement.scrollHeight - window.innerHeight;
      const pct = total > 0 ? scrolled / total : 0;
      setVisible(pct > 0.35 && pct < 0.9);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const show = visible && !dismissed;

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          className="fixed bottom-24 md:bottom-6 left-1/2 -translate-x-1/2 z-40"
          data-testid="sticky-cta"
        >
          {/* Mobile compact version */}
          <div className="md:hidden flex items-center gap-2 bg-[var(--bb-bg-2)]/95 backdrop-blur-xl border border-[var(--bb-border-strong)] pl-3 pr-1 py-1.5 shadow-[0_20px_60px_-20px_rgba(14,155,106,0.35)]">
            <span className="relative flex items-center justify-center shrink-0">
              <span className="w-1.5 h-1.5 rounded-full bg-[var(--bb-copper)]" />
              <span className="absolute w-1.5 h-1.5 rounded-full bg-[var(--bb-copper)] animate-ping opacity-70" />
            </span>
            <button
              type="button"
              onClick={onBook}
              className="font-mono text-[10px] tracking-[0.2em] uppercase px-3 py-2 bg-[var(--bb-text)] text-[var(--bb-bg)] hover:bg-[var(--bb-copper)] hover:text-[var(--bb-text)] transition-colors"
              data-testid="sticky-cta-button-mobile"
            >
              Agendar reunión ↗
            </button>
            <button
              type="button"
              onClick={() => setDismissed(true)}
              aria-label="cerrar"
              className="w-7 h-7 flex items-center justify-center text-[var(--bb-muted)] hover:text-[var(--bb-text)] shrink-0"
              data-testid="sticky-cta-dismiss-mobile"
            >
              <span className="text-lg leading-none">×</span>
            </button>
          </div>

          {/* Desktop full version */}
          <div className="hidden md:flex items-center gap-5 bg-[var(--bb-bg-2)]/95 backdrop-blur-xl border border-[var(--bb-border-strong)] pl-6 pr-2 py-2 shadow-[0_20px_60px_-20px_rgba(14,155,106,0.35)]">
            <span className="relative flex items-center justify-center shrink-0">
              <span className="w-2 h-2 rounded-full bg-[var(--bb-copper)]" />
              <span className="absolute w-2 h-2 rounded-full bg-[var(--bb-copper)] animate-ping opacity-70" />
            </span>
            <div className="flex flex-col leading-tight">
              <span className="mono-label text-[10px] text-[var(--bb-copper-light)]">
                DISPONIBILIDAD · 2025
              </span>
              <span className="font-display text-[15px] text-[var(--bb-text)] tracking-tight">
                ¿Listo para desplegar IA agéntica?
              </span>
            </div>
            <button
              type="button"
              onClick={onBook}
              className="bb-cta shrink-0"
              data-testid="sticky-cta-button"
            >
              <span>Agendar 30 min</span>
              <span aria-hidden>↗</span>
            </button>
            <button
              type="button"
              onClick={() => setDismissed(true)}
              aria-label="cerrar"
              className="w-8 h-8 flex items-center justify-center text-[var(--bb-muted)] hover:text-[var(--bb-text)] shrink-0"
              data-testid="sticky-cta-dismiss"
            >
              <span className="text-lg leading-none">×</span>
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
